<template>
    <div class="drawer drawer-right drawer-sla-overview dw-xs-10 dw-sm-6 dw-md-3 fold" aria-labelledby="drawer-sla-overview">
        <div class="drawer-contents">

            <div class="drawer-heading <?php echo $theme_base; ?>">
                <h2 class="drawer-title">
                    Edit SLA Overview
                </h2>
                <a href=".drawer-sla-overview" data-toggle="drawer" aria-foldedopen="false" aria-controls="drawer-sla-overview" class="btn btn-close-drawer">
                    <i class="far fa-times"></i>
                </a>
            </div><!-- /.drawer-heading -->

            <div class="drawer-body">

                <div class="form-group form-group-material">
                    <label class="control-label">Cluster</label>
                    <selectize
                        v-if="clients.length"
                        :options="clients"
                        name="client_id"
                        class="selectize single"
                        placeholder="Select one"
                        :searchable="false"
                        v-model="editSLA.client_id"
                        v-validate="'required'"
                        data-vv-as="client"
                    >
                    </selectize>

                    <help-block field="client_id"/>
                </div><!-- /.form-group -->


                <div class="form-group form-group-material">
                    <label class="control-label">App Url</label>
                    <input
                        name="contact_email"
                        v-model="editSLA.contact_email"
                        type="email"
                        class="form-control"
                        v-validate="'required|email'"
                        data-vv-validate-on="input|blur"
                        data-vv-as="contact email"
                    />

                    <help-block field="ned_date"/>
                </div><!-- /.form-group -->

                <div class="form-group form-group-material">
                    <label class="control-label">API Url</label>
                    <input
                        name="contact_email"
                        v-model="editSLA.contact_email"
                        type="email"
                        class="form-control"
                        v-validate="'required|email'"
                        data-vv-validate-on="input|blur"
                        data-vv-as="contact email"
                    />

                    <help-block field="start_date"/>
                </div><!-- /.form-group -->

                <div class="form-group form-group-material">
                    <label class="control-label">RDS Host</label>
                    <input
                        name="contact_email"
                        v-model="editSLA.contact_email"
                        type="email"
                        class="form-control"
                        v-validate="'required|email'"
                        data-vv-validate-on="input|blur"
                        data-vv-as="contact email"
                    />

                    <help-block field="contact_email"/>
                </div><!-- /.form-group -->

                <button type="button" class="btn btn-rounded btn-default" data-toggle="drawer" data-target=".drawer-sla-overview" aria-foldedopen="false" aria-controls="drawer-sla-overview">Cancel</button>
                <ladda-button :on-click="handleSaveSla" class="btn btn-rounded btn-primary">Save</ladda-button>

            </div><!-- /.drawer-body -->

        </div><!-- /.drawer-contents -->
    </div><!-- /.drawer -->

</template>

<style>
    .form-control {
        box-shadow: none !important;
    }

    .form-control[readonly] {
        background-color: transparent !important;
    }
</style>

<script>

    import { mapActions, mapState } from 'vuex'
    import { http } from 'utils'
    import { Selectize, LaddaButton } from 'components/form/input'
    import Datepicker from 'vuejs-datepicker'
    import $ from 'jquery'
    import { notify } from 'utils'
    import { unset, cloneDeep } from 'lodash'
    import moment from 'moment'

    export default {
        components: {
            Selectize,
            LaddaButton,
            Datepicker
        },

        data() {
            return {
                clients: [],
                types: [],
                editSLA: {}
            }
        },

        created() {
            this.fetchData()
        },

        mounted() {
            $('.drawer-sla-overview').on('show.bs.drawer', () => {
                this.editSLA = cloneDeep(this.sla)
            });
        },

        computed: {
            ...mapState('sla', ['sla'])
        },

        methods: {
            ...mapActions('sla', ['updateSLA']),

            fetchData() {

                Promise.all([
                    http.get(`/clients/list`).then(response => {

                      return response.data
                    }),
                    http.get(`/sla/types`).then(response => {

                      return response.data
                    })
                ]).then((data) => {
                    this.clients = data[0]
                    this.types = data[1]
                })
            },

            async handleSaveSla() {
                if (!await this._validate()) {
                    notify.error('Form validation failed, please check your inputs and try again.')
                    return Promise.reject()
                }

                let payload = {
                    id: this.sla.id,
                    payload: {
                        contact_email: this.editSLA.contact_email,
                        contact_firstname: this.editSLA.contact_firstname,
                        contact_surname: this.editSLA.contact_surname,
                        client_id: this.editSLA.client_id,
                        type_id: this.editSLA.type_id,
                        start_date: moment(this.editSLA.start_date).format('YYYY-MM-DD'),
                        end_date: moment(this.editSLA.end_date).format('YYYY-MM-DD'),
                        monthly_hours: this.editSLA.monthly_hours,
                        override_rate: this.editSLA.override_rate
                    }
                }

                return this.updateSLA(payload).then(() => {
                    //close side drawer
                    notify.success('SLA successfuly updated.')
                    $('.drawer-sla-overview').drawer('hide')
                }).catch((error) => {
                    if (error.response.status === 422) {
                        notify.error('Form validation failed, please check your inputs and try again.')
                    } else {
                        notify.error('Failed to update sla details, please try again.')
                    }
                })
            }
        }
    }
</script>
